import React from 'react';
import PropTypes from 'prop-types';
import DotBadge from '../DotBadge/DotBadge';

import styles from './styles';
export const ShapeColor = {
  GREEN: 'Green',
  BLUE: 'Blue',
  MUSTARD: 'Mustard',
  RED: 'Red',
  ORANGE: 'Orange',
  WHITE: 'White',
  GREY: 'Grey',
  PINK: 'Pink',
  BLACK: 'Black',
  PRIORITY: 'Priority',
}

export const ShapeTypes = {
  CIRCLE: 'Circle',
  POTATO: 'Potato',
}

export const ShapeThemes = {
  SOLID: 'Solid',
  SOFT: 'Soft',
  TRANSPARENT: 'Transparent',
}

export const ShapeSize = {
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',

}

/**
 * Stateless component to draw an Ball.
 * @param {string} classBall CSS class name for Ball, must exist in icoFonts.scss.
 * @param {string} wrapperClass CSS class name for the wrapper div of Ball and label.
 * @param {bool} badge Sets if the Ball has a red dot.
 * @param {string} label Ball's label.
 * @param {string} title Title on wrapper.
 * @param {func} onClick Function executed by clicking the Ball.
 * @returns {JSX} Component JSX.
 */
const Shape = ({
  wrapperClass,
  badge,
  type,
  theme,
  color,
  size,
  children,
}) => {
  // JSX to create the Shape Component visualization
  return (
    <>

    <div
      className={`ShapeWrapper ${wrapperClass} size${size}`}
      role="button"
      tabIndex="-1"
    >
      <div className={`shape ${theme} ${color} size${size} ${type}`}>
        <div className="shapeCombo">
          {children}
        </div>
      </div>
      {badge && <DotBadge />}
    </div>
    <style jsx>{styles}</style>
    </>
  )
}

// Proptypes for the Ball props
Shape.propTypes = {
  wrapperClass: PropTypes.string,
  badge: PropTypes.bool,
  type: PropTypes.string,
  theme: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
};

// Default values for non required props
Shape.defaultProps = {
  badge: false,
  wrapperClass: '',
  type: ShapeTypes.CIRCLE,
  theme: ShapeThemes.SOLID,
  size: 'M',
  color: ShapeColor.BLUE,
};

export default Shape;
